import { Model } from "@vuex-orm/core";
import CustomerLookup from "./CustomerLookup";

export default class ChatLookup extends Model {
  static entity = "chatLookups";

  static fields() {
    return {
      id: this.attr(),
      customerId: this.number().nullable(),
      name: this.attr().nullable(),
      chatSource: this.attr(),
      isNotEnded: this.boolean(false),
      isUnread: this.boolean(false),
      haveNotResponded: this.boolean(false),
      message: this.attr(),
      customer: this.belongsTo(CustomerLookup, "customerId"),
      chatMessageCreatedAt: this.attr(),
      chatsSnoozedUntil: this.attr()
    };
  }
}
